import transactionSession from '../instance';

const openTransaction = (contextType, state) => {
  const { id, initialState, context, isDedicated } = transactionSession.get();

  if (id) {
    if (!isDedicated) {
      throw new Error('Another transaction session is opened now');
    }

    if (contextType !== context) {
      throw new Error('Passed contextType does not match the context of the opened transaction');
    }
  } else {
    transactionSession.open(contextType);
  }

  if (!initialState) {
    transactionSession.setInitialState(state);
  }
};

export default openTransaction;
